module.exports = __webpack_public_path__ + "static/index/img/baikal-703.50cef3e0.jpg";